import React, { useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import useChapterActionIdMatch from "../../../../hooks/useChapterActionIdMatch";

import ToolBlock from "../../../../components/AdministrativeProcedures/commonComponents/ToolBlock/ToolBlock";
import SearchBlockRHF from "../../../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";
import TableComponent from "../../../../components/GeneralComponents/SearchTable/tableComponent";

import {
  options,
  setOptionsSections,
  setOptionsStatus,
} from "../../../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import { getDataPrintCertificatesBySearchParams } from "../../../../redux/printCertificatesReducer/actionsPrintCertificates";

import { columnsForSearchTableCertificatesForPrint } from "./columnsForSearchTableCertificatesForPrint";

import styles from "./SearchCertificatesForPrint.module.css";

function SearchCertificatesForPrint() {
  const dispatch = useDispatch();

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedPage, setSelectedPage] = useState(0);
  const [checkedElements, setCheckedElements] = useState([]);
  const [searchParams, setSearchParams] = useState({
    surname: "",
    name: "",
    midname: "",
    apptype: 0,
    appDate: "",
    status: 0,
    section: 0,
    licenseType: 0,
  });
  const [propsForButtons, setPropsForButtons] = useState({
    disabledButtonView: false,
    disabledButtonEdit: false,
    disabledButtonPrint: true,
  });
  const [clearSelectedRowsTrigger, setClearSelectedRowsTrigger] = useState(false);

  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });
  const statePrintCertificates = useSelector((state) => {
    const { printCertificatesReducer } = state;
    return printCertificatesReducer;
  });
  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });

  const printAccess = useChapterActionIdMatch(
    sortedMenuNames?.PRINT_CERTIFICATES?.printingIDs?.chapterActionId,
  );
  const viewAccess = useChapterActionIdMatch(
    sortedMenuNames?.PRINT_CERTIFICATES?.applicationPreview?.chapterActionId,
  );
  const editAccess = useChapterActionIdMatch(
    sortedMenuNames?.PRINT_CERTIFICATES?.specifyTheIdNumber?.chapterActionId,
  );

  const handleRowSelect = (data) => {
    setSelectedRowData(data);

    const result = data;
    switch (true) {
      case result.length === 1 && result[0].statusId === 3: {
        setPropsForButtons({
          disabledButtonView: false,
          disabledButtonEdit: false,
          disabledButtonPrint: true,
        });
        break;
      }
      case result.length === 1 && result[0].statusId !== 5: {
        setPropsForButtons({
          disabledButtonView: true,
          disabledButtonEdit: false,
          disabledButtonPrint: true,
        });
        break;
      }
      case result.length === 1 && result[0].statusId === 5: {
        setPropsForButtons({
          disabledButtonView: true,
          disabledButtonEdit: true,
          disabledButtonPrint: true,
        });
        break;
      }
      case result.length !== 0 &&
        result.length % 4 === 0 &&
        result.every((obj) => obj["licenseTypeId"] === result[0]["licenseTypeId"]) &&
        result.every((obj) => obj["statusId"] === 4 || obj["statusId"] === 3): {
        setPropsForButtons({
          disabledButtonView: false,
          disabledButtonEdit: false,
          disabledButtonPrint: false,
        });
        break;
      }
      case result.length === 0 || (result.length !== 0 && result.length % 4 !== 0): {
        setPropsForButtons({
          disabledButtonView: false,
          disabledButtonEdit: false,
          disabledButtonPrint: true,
        });
        break;
      }
      default: {
        setPropsForButtons({
          disabledButtonView: false,
          disabledButtonEdit: false,
          disabledButtonPrint: true,
        });
      }
    }
    setCheckedElements(result);
  };

  const handleChange = (e) => {
    if (e.target) {
      setSearchParams({
        ...searchParams,
        [e.target.dataset.id]: e.target.value,
      });
    } else {
      setSearchParams({ ...searchParams, [e.key]: e.value });
    }
  };
  const handleSearch = () => {
    dispatch(getDataPrintCertificatesBySearchParams(searchParams, 0));
    setSelectedPage(0);
    setSelectedRowData(null);
  };

  const fetchPageData = (pageIndex) => {
    setSelectedPage(pageIndex);
  };

  const handleClear = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    setSearchParams(
      structuredClone({
        surname: "",
        name: "",
        midname: "",
        apptype: 0,
        appDate: "",
        status: 0,
        section: 0,
        licenseType: 0,
      }),
    );
    dispatch(
      getDataPrintCertificatesBySearchParams(
        {
          surname: "",
          name: "",
          midname: "",
          apptype: 0,
          appDate: "",
          status: 0,
          section: 0,
          licenseType: 0,
        },
        0,
      ),
    );
  };

  useMemo(() => {
    dispatch(getDataPrintCertificatesBySearchParams(searchParams, selectedPage));
  }, [selectedPage]);

  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(dictionaryReducer.gimsSections, options.inputsPrintCertificates.key);
    }
    if (dictionaryReducer.statusIssuanceCertificates.length > 0) {
      setOptionsStatus(dictionaryReducer.statusIssuanceCertificates, options.inputsPrintCertificates.key);
    }
  }, [dictionaryReducer]);

  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(dictionaryReducer.gimsSections, options.inputsPrintCertificates.key);
    }
    if (dictionaryReducer.statusIssuanceCertificates.length > 0) {
      setOptionsStatus(dictionaryReducer.statusIssuanceCertificates, options.inputsPrintCertificates.key);
    }
  }, []);

  useEffect(() => {
    fetchPageData(0);
  }, []);

  useEffect(() => {
    setSelectedRowData(null);
    setPropsForButtons({ ...propsForButtons, disabledButtonPrint: true });
  }, [statePrintCertificates.searchData.content]);

  return (
    <div className={styles["content-container"]}>
      <SearchBlockRHF
        options={options.inputsPrintCertificates}
        handleChange={handleChange}
        handleSearch={handleSearch}
        handleClear={handleClear}
        searchParams={searchParams}
        externalStyles={styles}
      />
      <ToolBlock
        data={checkedElements}
        propsForButtons={propsForButtons}
        editAccess={editAccess}
        viewAccess={viewAccess}
        printAccess={printAccess}
        searchParams={searchParams}
        selectedPage={selectedPage}
      />
      <TableComponent
        fetchData={fetchPageData}
        onRowSelect={handleRowSelect}
        columns={columnsForSearchTableCertificatesForPrint}
        data={statePrintCertificates.searchData.content || []}
        totalPages={statePrintCertificates.searchData.totalPages || 0}
        totalElements={statePrintCertificates.searchData.totalElements || 0}
        selectedPage={selectedPage}
        multiSelect={true}
        clearSelectedRows={clearSelectedRowsTrigger}
      />
    </div>
  );
}

export default SearchCertificatesForPrint;
